"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledPx2rem = _interopRequireDefault(require("../../utils/styled-px2rem"));
var _templateObject;
var _excluded = ["children"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Badge = /*#__PURE__*/function (_React$PureComponent) {
  function Badge() {
    (0, _classCallCheck2["default"])(this, Badge);
    return _callSuper(this, Badge, arguments);
  }
  (0, _inherits2["default"])(Badge, _React$PureComponent);
  return (0, _createClass2["default"])(Badge, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(StyledBadge, props, children);
    }
  }]);
}(_react["default"].PureComponent);
Badge.propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  primary: _propTypes["default"].bool
};
Badge.defaultProps = {
  className: '',
  primary: false
};
var StyledBadge = _styledPx2rem["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  color: #17181a;\n  display: inline-block;\n  font-size: 12px;\n\n  ", "\n"])), function (props) {
  return props.primary && "\n    background-color: #f8e71c;\n    border-radius: 30px;\n    padding: 3px 6px;\n  ";
});
var _default = exports["default"] = Badge;